import { UPDATE_PROJECT_SIMULATOR_VALUE } from '../actions/projectSimulator';

export type ProjectSimulatorDTO = {
  projectSimulator: {
    isPatched: boolean;
  };
};

const initialState: ProjectSimulatorDTO['projectSimulator'] = {
  isPatched: false,
};

function projectSimulatorReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PROJECT_SIMULATOR_VALUE:
      return {
        ...state,
        [action.name]: action.value,
      };

    default:
      return state;
  }
}

export default projectSimulatorReducer;
